// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/schraubenfeder/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const schraubenfederDE: PageEntry = {
  id: "post.schraubenfeder",
  locale: "de",
  slug: "schraubenfeder",
  seo: {
    title: "Glossar: Schraubenfeder einfach erklärt | Dietz GmbH",
    description: "Schraubenfedern sind spiralig gewundene Metallfedern, die aufgrund ihrer Form und Struktur eine elastische Verformung ermöglichen. Diese Federn werden häufig in mechanischen System",
  },
  type: "post",
  h1: "Glossar: Schraubenfeder einfach erklärt",
  intro: "Schraubenfedern sind spiralig gewundene Metallfedern, die aufgrund ihrer Form und Struktur eine elastische Verformung ermöglichen. Diese Federn werden häufig in mechanischen Systemen eingesetzt, um Kräfte abzufangen, zu speichern oder zu übertragen. Die Konstruktion einer Schraubenfeder ermöglicht es ihr, unter Belastung Energie zu speichern und diese bei Bedarf wieder freizusetzen. Dies macht sie besonders geeignet für Anwendungen wie Stoßdämpfer in Fahrzeugen, Federn in Schließmechanismen oder zur Vorspannung von Bauteilen. Die Auswahl der richtigen Schraubenfeder hängt von Parametern wie Federkonstante, Materialwahl und Federgeometrie ab.",
  blocks: [

  ],
};
